module.exports = __webpack_public_path__ + "static/img/titleBackground.12141c6b.png";